import React, { Component } from 'react'
import apiService from '../../services/apiservices'
import Select from 'react-select'

class Cities extends Component {
    constructor() {
        super()
        this.state = {
            cityList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getCityList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getCityList = () => {
        apiService.getCityDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        cityList: listData
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}
        list = Object.keys(this.state.cityList).map((index) => {
            return {
                label : this.state.cityList[index]['name'],
                value : this.state.cityList[index]['name'],
                state_name : this.state.cityList[index]['state'],
                country_name : this.state.cityList[index]['country']
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select City"
                options={list}
                onChange={(e) => { (e) ? this.props.cityChange(e) : this.props.cityChange([])}}
                />
            </div>
        )
    }
}
export default Cities


// WEBPACK FOOTER //
// ./src/modules/Teams/Components/DropDowns/Cities.js